import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa1fdd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "modal-card-head" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Карточка заказа")
], -1))
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Действия", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Основное", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Агент", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Статус", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Бухгалтер", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "content" }
const _hoisted_16 = {
  key: 0,
  class: "table"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "first-column" }, "Идентификатор", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Имя", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Почта", -1))
const _hoisted_20 = {
  key: 1,
  class: "table"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "first-column" }, "Идентификатор", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ФИО", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Аккаунт", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Выведено за этот год", -1))
const _hoisted_25 = {
  key: 2,
  class: "table"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "first-column" }, "Идентификатор", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дата создания", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "БИК банка", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Расчетный счет", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Сумма", -1))
const _hoisted_31 = { key: 3 }
const _hoisted_32 = {
  key: 0,
  class: "actions_empty"
}
const _hoisted_33 = { class: "table" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "first-column" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Может быть выгружен в Excel", -1))
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "first-column" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Подтвердить оплату", -1))
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { class: "first-column" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Вернуть бонусы агенту", -1))
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { class: "first-column" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Заблокировать заказ", -1))
const _hoisted_46 = {
  key: 4,
  class: "table"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "first-column" }, "Идентификатор", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Название для агента", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Название системное", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Финальный статус", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "modal-close is-large",
  "aria-label": "close"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.model !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-background",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("section", {
            class: _normalizeClass(["modal-card-body with-scrollbar", {busy: _ctx.ctx.isEntityLoading}])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.ACTIONS }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = _ctx.tabNames.ACTIONS))
                }, _hoisted_6, 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.GENERAL }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = _ctx.tabNames.GENERAL))
                }, _hoisted_8, 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.AGENT }),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = _ctx.tabNames.AGENT))
                }, _hoisted_10, 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.STATUS }),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = _ctx.tabNames.STATUS))
                }, _hoisted_12, 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.USER }),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = _ctx.tabNames.USER))
                }, _hoisted_14, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.tab === _ctx.tabNames.USER)
                ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_17,
                        _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.user?.id), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_18,
                        _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.user?.name), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_19,
                        _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.user?.email), 1)
                      ])
                    ])
                  ]))
                : (_ctx.tab === _ctx.tabNames.AGENT)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_21,
                          _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.agent.id), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_22,
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'AgentsCard', params: { agent: _ctx.model.agent.id } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.model.agent.fullname), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_23,
                          _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.agent.is_banned ? 'Заблокирован':'Активен'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_24,
                          _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.agent.statistic.orders_paid.last_year), 1)
                        ])
                      ])
                    ]))
                  : (_ctx.tab === _ctx.tabNames.GENERAL)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_25, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_26,
                            _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.id), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_27,
                            _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.created_at), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_28,
                            _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.bic), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_29,
                            _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.check_acc), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_30,
                            _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.amount), 1)
                          ])
                        ])
                      ]))
                    : (_ctx.tab === _ctx.tabNames.ACTIONS)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (!_ctx.orderHasAction())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Нет доступных действий"))
                            : _createCommentVNode("", true),
                          _createElementVNode("table", _hoisted_33, [
                            _createElementVNode("tbody", null, [
                              (_ctx.canBeInProgress())
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                    _createElementVNode("th", _hoisted_35, [
                                      _createElementVNode("button", {
                                        class: "button is-light is-info button-action",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ctx.changeStatusOnProcess()))
                                      }, "Взять в работу")
                                    ]),
                                    _hoisted_36
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.canBePaid())
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                    _createElementVNode("th", _hoisted_38, [
                                      _createElementVNode("button", {
                                        class: "button is-light is-success button-action",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.ctx.changeStatusOnPay()))
                                      }, "Оплатить")
                                    ]),
                                    _hoisted_39
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.canBeReverted())
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                    _createElementVNode("th", _hoisted_41, [
                                      _createElementVNode("button", {
                                        class: "button is-light is-warning button-action",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ctx.changeStatusOnRevert()))
                                      }, "Вернуть")
                                    ]),
                                    _hoisted_42
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.canBeError())
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                    _createElementVNode("th", _hoisted_44, [
                                      _createElementVNode("button", {
                                        class: "button is-light is-danger button-action",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ctx.changeStatusOnError()))
                                      }, "Ошибка")
                                    ]),
                                    _hoisted_45
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_ctx.tab === _ctx.tabNames.STATUS)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_46, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_47,
                                _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.status.id), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_48,
                                _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.status.name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_49,
                                _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.status.system_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_50,
                                _createElementVNode("td", null, _toDisplayString(_ctx.ctx.entity.status.is_lock ? 'Да':'Нет'), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
            ])
          ], 2),
          _hoisted_51
        ])
      ]))
    : _createCommentVNode("", true)
}